<template>
  <div class="hunters">
    <h2 class="title">
      {{ $t('pages.hunters' ) }}
    </h2>

    <div class="scrollbar">
      <ts-hunter
        v-for="hunter in hunters"
        :key="hunter.id"
        :hunter="hunter"
        @edit="edit"
      />
    </div>

    <div class="buttons">
      <el-button type="warning" round @click="create">
        {{ $t('add') }}
      </el-button>
    </div>

    <el-dialog
      :title="form.hunter_id ? $t('edit') : $t('add')"
      :visible.sync="showHunterForm"
      :modal-append-to-body="false"
    >
      <el-form ref="hunterForm">
        <el-row>
          <el-col :span="4">
            <el-upload
              class="photo-uploader"
              action="#"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="uploadAvatar"
            >
              <el-image
                class="image"
                :src="form.avatar | avatar64"
                fit="cover"
              />
            </el-upload>
          </el-col>
          <el-col :span="20">
            <el-form-item :label="$t('name')" prop="name">
              <el-input v-model="form.name" type="text" autocomplete="off" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item :label="$t('whatsApp')" prop="phone">
              <el-input v-model="form.phone" type="text" autocomplete="off" />
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form ref="emailForm" style="padding-left: 10px">
              <el-form-item :label="$t('email')" prop="email">
                <el-input v-model="form.email" type="text" autocomplete="off" />
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="form.hunter_id" type="text" style="float: left;color: #EF5757" @click="destroy">
          {{ $t('delete') }}
        </el-button>
        <el-button type="text" @click="cancel">
          {{ $t('cancel') }}
        </el-button>
        <el-button type="warning" round @click="save">
          {{ form.hunter_id ? $t('save') : $t('add') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { createHunter, updateHunter, deleteHunter } from '@/api/hunters'
  import Hunter from './Hunter.vue'

  export default {
    components: {
      'ts-hunter': Hunter
    },

    data() {
      return {
        showHunterForm: false,
        form: {
          // eslint-disable-next-line @typescript-eslint/camelcase
          hunter_id: null,
          avatar: null,
          file: null,
          name: '',
          phone: '',
          email: ''
        }
      }
    },

    computed: {
      hunters() {
        return this.$store.state.Hunters.list
      }
    },

    created() {
      this.getList()
    },

    methods: {
      getList() {
        this.$store.dispatch('Hunters/getHunters')
      },

      create() {
        this.showHunterForm = true
      },

      edit(hunter) {
        // eslint-disable-next-line @typescript-eslint/camelcase
        this.form.hunter_id = hunter.id
        this.form.name = hunter.profile.name
        this.form.phone = hunter.profile.phone
        this.form.email = hunter.email
        this.form.avatar = hunter.avatar
        this.showHunterForm = true
      },

      cancel() {
        this.resetForm()
      },

      save() {
        if (this.form.hunter_id) {
          this.update()
        } else {
          this.store()
        }
      },

      async store() {
        createHunter(this.getParam())
          .then(() => {
            this.$store.dispatch('Hunters/getHunters')
            this.resetForm()
          })
      },

      async update() {
        updateHunter(this.getParam())
          .then(() => {
            this.$store.dispatch('Hunters/getHunters')
            this.resetForm()
          })
      },

      async destroy() {
        deleteHunter(this.form.hunter_id)
          .then(() => {
            this.$store.dispatch('Hunters/getHunters')
            this.resetForm()
          })
      },

      getParam() {
        const data = new FormData()

        data.append('hunter_id', this.form.hunter_id)
        data.append('name', this.form.name)
        data.append('phone', this.form.phone)
        data.append('email', this.form.email)

        if (this.form.file) {
          data.append('avatar', this.form.file)
        }

        return data
      },

      uploadAvatar(file) {
        this.form.file = file.raw
        this.form.avatar = {
          // eslint-disable-next-line @typescript-eslint/camelcase
          thumb_64: URL.createObjectURL(file.raw)
        }
      },

      resetForm() {
        // eslint-disable-next-line @typescript-eslint/camelcase
        this.form.hunter_id = null
        this.form.avatar = null
        this.form.file = null
        this.form.name = ''
        this.form.email = ''
        this.form.phone = ''
        this.showHunterForm = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../assets/variables';

  .hunters {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 20px;
    left: 0;
    z-index: 500;

    .scrollbar {
      height: 80%;
    }

    .title {
      font-weight: 600;
      font-size: 22px;
      line-height: 36px;
      color: $color-text-regular;
      margin-bottom: 30px;
    }

    .photo-uploader {
      position: relative;
      width: 80px;

      .el-image {
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }
    }

    .buttons {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 60%;
    }
  }
</style>
